import React from 'react';
import PropTypes from 'prop-types';

import styled from 'styled-components';
import { NitroHeading, NitroParagraph } from 'nitro-components';

import { connect } from 'react-redux';
import {
  getBusinessReports,
  getReportsCCAndCountry,
  getReportsCCAndCountryLocal
} from '../../../selector';

const Content = styled.div`
  display: flex;
  ${'' /* justify-content: space-around; */};
`;

const Section = styled.div`
  width: 33.33%;
`;

const genLabel = data => data.map(d => d.label).join(' , ');

const mockedDynaFilters = [
  {
    title: 'State',
    typeId: 3,
    source: [
      {
        label: 'ACT',
        value: 'ACT'
      },
      {
        label: 'NSW',
        value: 'NSW'
      },
      {
        label: 'QLD',
        value: 'QLD'
      },
      {
        label: 'VIC',
        value: 'VIC'
      }
    ],
    value: []
  },
  {
    title: 'Classification',
    typeId: 4,
    source: [
      {
        label: 'Heavy Commercial',
        value: 'Heavy Commercial'
      },
      {
        label: 'Passenger',
        value: 'Passenger'
      }
    ],
    value: [
      {
        label: 'Heavy Commercial',
        value: 'Heavy Commercial'
      },
      {
        label: 'Passenger',
        value: 'Passenger'
      }
    ]
  }
];

const Source = ({ country, costcenter, businessReport, dynamicFilters }) => {
  const dynamicFiltersSections = dynamicFilters.map((f, idx) => (
    <Section key={idx}>
      <NitroHeading
        align="center"
        label={f.title}
        size="3"
        variant="secondary"
      />
      <NitroParagraph align="center">{genLabel(f.value)}</NitroParagraph>
    </Section>
  ));

  return (
    <Content>
      <Section>
        <NitroHeading
          align="center"
          label="Country"
          size="3"
          variant="secondary"
        />
        <NitroParagraph align="center">{country.label}</NitroParagraph>
      </Section>
      <Section>
        <NitroHeading
          align="center"
          label="Company Code"
          size="3"
          variant="secondary"
        />
        <NitroParagraph align="center">{costcenter.label}</NitroParagraph>
      </Section>
      {dynamicFiltersSections}
      <Section>
        <NitroHeading
          align="center"
          label="Business report"
          size="3"
          variant="secondary"
        />
        <NitroParagraph align="center">{businessReport.name}</NitroParagraph>
      </Section>
    </Content>
  );
};

Source.propTypes = {};

// TODO: move to selector
const mapStateToProps = state => {
  const { businessReportId, dynamicFilters } = state.reports;

  const businessReports = getBusinessReports(state);

  const businessReport = businessReports.find(r => r.id === businessReportId);
  return {
    businessReport,
    dynamicFilters,
    ...getReportsCCAndCountryLocal(state)
  };
};

export default connect(mapStateToProps)(Source);



// WEBPACK FOOTER //
// ./src/features/scheduling-reports/new-report/Summary/Sections/Source.js